var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextalignLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 4.8125H2.75C2.37417 4.8125 2.0625 4.50083 2.0625 4.125C2.0625 3.74917 2.37417 3.4375 2.75 3.4375H19.25C19.6258 3.4375 19.9375 3.74917 19.9375 4.125C19.9375 4.50083 19.6258 4.8125 19.25 4.8125Z",
    fill: "#0E1111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4308 9.39587H2.75C2.37417 9.39587 2.0625 9.08421 2.0625 8.70837C2.0625 8.33254 2.37417 8.02087 2.75 8.02087H11.4308C11.8067 8.02087 12.1183 8.33254 12.1183 8.70837C12.1183 9.08421 11.8158 9.39587 11.4308 9.39587Z",
    fill: "#0E1111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 13.9791H2.75C2.37417 13.9791 2.0625 13.6675 2.0625 13.2916C2.0625 12.9158 2.37417 12.6041 2.75 12.6041H19.25C19.6258 12.6041 19.9375 12.9158 19.9375 13.2916C19.9375 13.6675 19.6258 13.9791 19.25 13.9791Z",
    fill: "#0E1111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4308 18.5625H2.75C2.37417 18.5625 2.0625 18.2508 2.0625 17.875C2.0625 17.4992 2.37417 17.1875 2.75 17.1875H11.4308C11.8067 17.1875 12.1183 17.4992 12.1183 17.875C12.1183 18.2508 11.8158 18.5625 11.4308 18.5625Z",
    fill: "#0E1111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextalignLeft);
export default __webpack_public_path__ + "static/media/textalign-left.5333b786443df4aaaf35270ef2a8d49b.svg";
export { ForwardRef as ReactComponent };